import React, { useEffect, useRef, useState } from "react";
import { useWindowResize } from "../../../../hooks/useWindowResize";
import { Container, Extratext, Input, InputErrorMessage, InputErrorSuggestion, Label } from "./InputVF.style";
import { useStore } from "../../../../store/store";
import { AccordionRoutesEnum } from "../../../../types/AccordionRoutes";

export enum InputTypeEnum {
  text = "text",
  tel = "tel",
  email = "email",
  date = "date",
  number = "number",
}

interface Props {
  id: string;
  name: string;
  type: InputTypeEnum;
  labelText: string;
  extraText?: string;
  placeholder: string;
  autocomplete: string;
  validated: boolean | undefined;
  minlength?: number;
  maxlength?: number;
  min?: string;
  step: AccordionRoutesEnum;
  value?: string;
  errorText?: string;
  errorSuggestionText?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
}

export default function InputVF({ id, name, type, labelText, extraText, placeholder, autocomplete, validated = undefined, minlength, maxlength, min, step, onChange, onBlur, value, errorSuggestionText, errorText }: Props) {
  const accordionRoute = useStore.useAccordionRoute();

  return (
    <Container>
      <Label htmlFor={id}>{labelText}</Label><br />
      <Input id={id} type={type} name={name} placeholder={placeholder} autoComplete={autocomplete} minLength={minlength} maxLength={maxlength} min={min} validated={validated} onChange={onChange} onBlur={onBlur} value={value} />
      {extraText && <Extratext>{extraText}</Extratext>}
      {validated !== undefined && accordionRoute === step && !validated && <InputErrorMessage>{ errorText && errorText} {errorSuggestionText && <InputErrorSuggestion>{errorSuggestionText}</InputErrorSuggestion>}</InputErrorMessage>}
    </Container>
  );
}
